/**
 * Configuraciones centralizadas para el módulo Registros de Uso
 */

// Configuración de API
export const API_CONFIG = {
    baseUrl: process.env.REACT_APP_API_BASCULA || 'https://backbascula.orussystem.com/Evbi/v1/data/evbi/',
    endpoints: {
        statistics: '/registros/estadisticas',
        users: '/registros/usuarios',
        filters: '/registros/filtros',
        export: '/registros/exportar',
    },
};

// Configuración de paginación
export const PAGINATION_CONFIG = {
    defaultRowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 25, 50],
};

// Configuración de umbrales de participación
export const PARTICIPATION_THRESHOLDS = {
    high: 75,    // >= 75% = verde
    medium: 50,  // >= 50% y < 75% = naranja/amarillo
    // < 50% = rojo
};

// Nombres de meses
export const MONTH_NAMES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

// Configuración de ordenamiento por defecto
export const DEFAULT_SORT = {
    orderBy: 'identificacion',
    order: 'asc',
};

export default {
    API_CONFIG,
    PAGINATION_CONFIG,
    PARTICIPATION_THRESHOLDS,
    MONTH_NAMES,
    DEFAULT_SORT,
};
